import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import HomePart1 from "./HomePart1";
import HomePart2 from "./HomePart2";
function Home() {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
            <meta name="robots" content="index,follow" />
            <title>Data Security Council of India</title>
            <meta property="og:type" content="page"></meta>
            <meta property="og:title" content="Data Security Council of India" ></meta>
            <meta property="og:description" content="Data Security Council of India" ></meta>
            <meta property="og:image" content= "https://www.dsci.in/files/content/media/images/2024/DSCI-Logo-Color-Transparent.png" ></meta>
            <meta property="og:url" content="https://www.dsci.in/" ></meta>
            <meta property="og:site_name" content="Data Security Council of India" ></meta>
            <meta name="twitter:title" content="DSCI"></meta>
            <meta name="twitter:description" content="Data Security Council of India"></meta>
            <meta name="twitter:image" content="https://www.dsci.in/files/content/media/images/2024/DSCI-Logo-Color-Transparent.png"></meta>
            <meta http-equiv="X-UA-Compatible" content="IE=edge"></meta>
        </Helmet>
      </HelmetProvider>
      <HomePart1 />
      {/* <HomePart2 />  */}
    </div>
  );
}

export default Home;
